import Joi from "joi";
export const NOTES_FORM_KEYS = {
    CONTENT: "content",
    HEADING: "heading",
    IMAGE: 'image',
    VALID_TILL: "expireAt"
  
}



export const notesFormSchema = Joi.object({
 
  [NOTES_FORM_KEYS.HEADING]: Joi.string().empty('').trim().label('Heading').max(500).messages({
    "string.pattern.base": "\"Heading\" needs to be a valid string"
  }),
  [NOTES_FORM_KEYS.CONTENT]: Joi.string().label('Content').trim().max(1000).required().messages({
    "string.pattern.base": "\"Content\" is not allowed to be empty"
  }),
  [NOTES_FORM_KEYS.VALID_TILL]: Joi.date().empty(null).label('Valid Till').messages({
    "string.pattern.base": "\"Valid Till\" needs to be a valid date"
  }),
 
})